<template>
  <div>
      <div class="get-started-container">
        <h1>Settings</h1>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="First Name">
            <el-input placeholder="First Name " type="text" v-model="form.firstName" >
            </el-input>
          </el-form-item>
          <el-form-item label="Last Name">
            <el-input placeholder="Last Name " type="text" v-model="form.lastName" >
            </el-input>
          </el-form-item>
          <el-form-item label="Email">
            <el-input placeholder="Email" type="text" v-model="form.email" >
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button @click="dialogVisible = true">Reset Password</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="get-started-btn" @click="onSubmit">Save</el-button>
          </el-form-item>
        </el-form>
        
      </div>
      <el-dialog title="Update Password" :visible.sync="dialogVisible">
        <el-form :model="form">
          <el-form-item label="Password">
            <el-input v-model="password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="Confirm Password" >
            <el-input v-model="passwordConfirm" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Cancel</el-button>
          <el-button  :loading="savingPassword" type="primary" @click="setNewPassword">Save</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'start',
  mounted: function(){
    var user = Parse.User.current();
    console.log(user);
    if(!user){
       this.$router.push('/login');
       return
    }
    this.form.firstName = user.get('firstName');
    this.form.lastName = user.get('lastName');
    this.form.email = user.get('email');
  },
  data () {
    return {
      savingPassword:false,
      dialogVisible:false,
      form: {
          firstName: null,
          lastName: null,
          email: null     
      },
      savingData: false,
      msg: 'This is the login',
      password:null,
      passwordConfirm:null,
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    setNewPassword: function(){
      var _this = this;
      if(this.password != this.passwordConfirm){
        alert('Passwords must match!')
        return
      }
      this.savingPassword = true;
      var user = Parse.User.current();
      user.set('password', this.password);
      user.save()
        .then(function(savedObject){
          _this.savingPassword = false;
          _this.dialogVisible = false;
          _this.$message({
              type: 'success',
              message: 'Your password was updated!'
            });
        }).catch(function(){
          _this.$message({
              type: 'error',
              message: 'There was an issue saving your password.'
            });
        })
    },
    onSubmit:function(){

      var _this = this;
      _this.savingData = true;
      var user = Parse.User.current();
      user.save(_this.form)
        .then(function(){
           _this.savingData = false;
            _this.$message({
              type: 'success',
              message: 'Your settings were changed!'
            });
        }).catch(function(err){
          _this.savingData = false;
            _this.$message({
              type: 'error',
              message: err.message
            });
        })
      //this.$router.push('/dashboard/');
    },
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    onUploadClicked:function openPicker() {
        window.fsClient.pick({
          fromSources:["local_file_system","imagesearch","facebook","instagram","dropbox"]
        }).then(function(response) {
          // declare this function to handle response
          handleFilestack(response);
        });
    }
  }
}
</script>

<style scoped>
.get-started-container{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;    
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  text-align: left;
}
.get-started-container form {
  max-width: 500px;
  margin:30px auto;
}
.get-started-container h1 {
  width: 100%;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
  font-family: prohibition;
  text-align: center;
  font-size: 30px;
  box-sizing: border-box;
}
.get-started-container .el_select {
  width: 100%;
}
.get-started-container a{
  color: #d7347d;
}
.get-started-container p{
  text-align: center;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.el-input-group__append{
  width: 40px;
}
.get-started-btn {
  width: 100%;
}
</style>
